<template>
  <transition>
    <div class="new_main" v-cloak>
      <div class="game_top">
        <div class="game_banner">
          <img :src="gamesList.details_img" alt />
          <span></span>
        </div>
        <div class="title borderNone animate__animated animate__fadeInUp">
          <div class="game_title">
            <span @click="goHome">首页</span> >
            <span @click="goGamesDetail">旗下游戏</span> >游戏详情
          </div>
          <img :src="gamesList.icon_img" alt class="game_top_img" v-if="gamesList.icon_img" />
          <div class="game_text">
            <h2>{{ gamesList.name }}</h2>
            <p>语言：{{ gamesList.language }}</p>
            <p>发行地区：{{ gamesList.dis_area }}</p>
          </div>
          <img :src="gamesList.awards_img" alt class="game_rig_img" v-if="gamesList.awards_img" />
        </div>
      </div>
      <div class="new_ul">
        <div class="new_con">
          <p v-html="gamesList.introduction">
            <!-- {{gamesList.introduction}} -->
          </p>
        </div>
      </div>
      <div class="game_feather">
        <h2>游戏特色</h2>
        <div class="game_more">
          <div class="demo-image__lazy fadeInRight">
            <el-image v-for="(item,index) in gamesList.snapshot_list" v-show="showPreviewImg" :key="index" :src="item" fit="scale-down" :preview-src-list="gamesList.snapshot_list"></el-image>
          </div>

          <!-- <img
                        :src="item"
                        alt=""
                        v-for="(item, index) in gamesList.snapshot_list"
                        :key="index"
                        @click="previewImgMore(index)"
          />-->
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { formatDate } from '@/assets/js/date.js'
export default {
  data() {
    return {
      id: this.$route.params.id,
      gamesList: {},
    }
  },
  filters: {
    formatDate: function (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd')
    },
  },
  computed: {
    showPreviewImg() {
      console.log('当前的尺寸', this.gamesList.snapshot_list.length)
      return this.gamesList.snapshot_list.length
    },
  },
  mounted() {
    this.getGamesDetail(this.id)
  },
  beforeDestroy() {},
  methods: {
    goHome: function () {
      this.$router.push({ path: '/' })
    },
    goGamesDetail: function () {
      this.$router.push({ path: '/produce' })
    },
    getGamesDetail: function (id) {
      let datas = {
        id: id,
      }
      this.getHttp(this, datas, '/front/game/info', function (obj, data) {
        obj.gamesList = data.data
        console.log('获得的游戏', obj.gamesList)
      })
    },
  },
}
</script>
<style scope lang="scss">
.el-image {
  margin-right: 0.1rem;
}
.el-image-viewer__close {
  transition: all 0.9s;
}
.el-image-viewer__close:hover {
  transform: scale(1.3, 1.3);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.demo-image__lazy {
  display: flex;
  min-width: 6rem;
  flex-shrink: 0.8;
  // justify-content: center;
  align-items: flex-start;
  // align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
}
.fadeInRight {
  animation-delay: 0.3s;
  animation: fadeInRight 0.6s ease;
}
@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.new_main {
  width: 100%;
  min-height: 9rem;
  background: url('../assets/pcImg/new/bg.jpg') no-repeat;
  background-size: 100% 100%;
  position: relative;
  padding-bottom: 1.2rem;
  .game_top {
    .game_banner {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 16.04%;
      img {
        width: 100%;
      }
      span {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.85);
      }
    }
    .game_title {
      position: absolute;
      top: 0.2rem;
      span {
        cursor: pointer;
        &:hover {
          color: #f08200;
        }
      }
    }
    .game_text {
      position: absolute;
      top: 0.68rem;
      left: 1.23rem;
      h2 {
        display: inline-block;
        color: white;
        font-size: 0.32rem;
        margin-bottom: 0.05rem;
      }
      p {
        color: #b3b2b1;
        font-size: 0.18rem;
      }
    }
    .game_top_img {
      width: 1rem;
      height: 1rem;
      position: absolute;
      top: 0.65rem;
      border: none;
      appearance: none;
      outline: none;
    }
    .game_rig_img {
      width: 2.64rem;
      height: 0.68rem;
      position: absolute;
      right: 0.3rem;
      top: 0.93rem;
    }
  }
  .game_ul {
    width: 100%;
    height: 2rem;
  }
  .game_feather {
    width: 12rem;
    position: relative;
    margin-top: 0.96rem;
    left: 50%;
    margin-left: -6rem;
    list-style: none;
    font-size: 0.3rem;
    color: #fff;
    font-weight: bold;
    .game_more {
      display: flex;
      width: 100%;
      height: auto;
      // height: 3.96rem;
      margin-top: 0.34rem;
      background: white;
      overflow-x: scroll;
      overflow-y: hidden;
    }
  }
  .title {
    width: 12rem;
    height: 2rem;
    position: absolute;
    top: 1.08rem;
    left: 50%;
    margin-left: -6rem;
    color: white;
    font-size: 0.16rem;
    border-bottom: 2px solid #383c44;
    cursor: default;
  }
  .borderNone {
    border-bottom: none;
  }
  .n_title {
    text-align: center;
  }
  .new_ul {
    width: 12rem;
    position: relative;
    margin-top: 0.48rem;
    left: 50%;
    margin-left: -6rem;
    list-style: none;
    font-size: 0.14rem;
    color: #fff;
    .new_title {
      color: #fff;
      text-align: center;
      font-size: 0.42rem;
    }
    .new_time {
      color: #b3b2b1;
      font-size: 0.2rem;
      text-align: right;
      margin-top: 34px;
      padding-bottom: 14px;
      border-bottom: 2px solid #383c44;
    }
    .new_con {
      font-size: 0.18rem;
      line-height: 0.45rem;
      cursor: default;
      p {
        text-indent: 2em;
      }
    }
    li {
      width: 100%;
      border-bottom: 1px solid #383c44;
      padding: 0.4rem;
      position: relative;
      cursor: pointer;
      z-index: 0;
      .new_title {
        color: white;
        font-size: 0.22rem;
        width: 80%;
        float: left;
        height: 0.6rem;
        line-height: 0.6rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
      .new_date {
        color: #b3b2b1;
        font-size: 0.18rem;
        width: 20%;
        float: left;
        height: 0.6rem;
        line-height: 0.6rem;
        text-align: right;
      }
      .new_detail {
        color: #b3b2b1;
        font-size: 0.16rem;
        width: 80%;
        float: left;
        height: 0.4rem;
        line-height: 0.4rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }
    li i {
      width: 0;
      height: 1px;
      content: '';
      background-color: #f08200;
      position: absolute;
      left: 50%;
      right: 50%;
      bottom: 0%;
      transition: all 0.7s;
      z-index: -1;
    }
    li:hover i {
      width: 100%;
      right: 0%;
      bottom: 0%;
      left: 0%;
    }
  }
  .new_page {
    width: 12rem;
    position: absolute;
    bottom: -0.5rem;
    left: 50%;
    margin-left: -6rem;
    text-align: center;
  }
}
</style>
